<div class="tooltip">
    <p *ngIf="text!==null">{{text}}</p>
    <ng-content></ng-content>
</div>
